import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';


interface Notification {
  pid: number; // Replace with actual ID type
  message: string; // Replace with actual message type
  // Add other properties as needed
  expiry_Date: string;
  created_at: string;
  dismissed : Number;
}
@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  _url= 'https://ciot.appointele.com/api';
  private notificationSubject = new Subject<Notification>();
  notification$ = this.notificationSubject.asObservable();

  private eventSource: EventSource | null = null;

  constructor(private zone: NgZone, private _http: HttpClient) {}

  // New method to start listening for notifications with userId and role
  startListening(userId: number, role: string, branch: string) {
    this.listenForNotifications(userId, role, branch);
  }

  private listenForNotifications(userId: number, role: string, branch: string) {
    if (this.eventSource) {
      this.eventSource.close(); // Close any existing connection
    }

    const startListening = () => {
   
      //role="Receptionist";
    // Set userId and role as query parameters in the EventSource URL
    const eventSource = new EventSource(`https://ciot.appointele.com/api/sse_notification.php?username=${userId}&role=${role}&branch=${branch}`);
   // console.log(eventSource);
   eventSource.onopen = () => {
   // console.log("SSE connection opened");
};

eventSource.onerror = (error) => {
    console.error("SSE connection error:", error);
    eventSource.close();  // Close if there's an error
};

    eventSource.addEventListener('notification', event => {
   //   console.log("Raw Event:", event);  // Log the raw event for debugging
      
      this.zone.run(() => {
      
        const notification = JSON.parse((event as MessageEvent).data);
       //console.log(notification);
        this.notificationSubject.next(notification); // Send message to subscribers
      });
    });

    eventSource.onerror = error => {
     // console.error('SSE Error:', error);
      eventSource.close();  // Optionally close connection on error
      setTimeout(startListening, 5000); // Retry after 5 seconds if connection closes
    };
  };
  startListening(); // Start the first connection
  }

   // Method to close connection when component is destroyed
   stopListening() {
    this.eventSource?.close();
  }


  dismissNotification(notificationId: number) {
    console.log(notificationId);
    return this._http.post('https://ciot.appointele.com/api/dismiss_notification.php', { notification_id: notificationId });
  }



  submitTicket(formData: FormData): Observable<any> {
    return this._http.post<any>(`${this._url}/helpdesk_ticket_insert.php`, formData);
  }

  getTicketById(id: string): Observable<any> {
    return this._http.get<any>(`${this._url}/ge_helpdesk_ticket.php?id=${id}`);
  }

  
  private handleError(error: HttpErrorResponse) {
    console.log(error.error);
   //console.error('Full error response:', error);  // Log the full error for inspection
    // return an observable with a user friendly message
    return throwError(error.error.text);
  }
}
